// @ts-nocheck
import angular from 'angular';
import {connectPopupController} from '@acng/frontend-discovery';
import {closest} from '@acng/frontend-bounty';

import {ImageTile} from 'acng/core/tiles/ImageTile';

import {ctxAmateur} from '../context/amateur.js';

/** also used in onsw-livecams-sidebar */
export const ignoreClicks = 'onsw-messenger-send, onsw-open-dialog-button, onsw-pin-button, .popup-close';

angular.module('amateurPool')

  .factory('AmateurTile', ['Amateur', (Amateur) => {
    class AmateurTile extends ImageTile {
      async load(scope, amateur_id) {
        try {
          const amateur = await Amateur.get(amateur_id);
          ctxAmateur.provide(this.box, amateur);
          connectPopupController(this.box);
          if (amateur.age > 35) {
            //throw `${amateur.nickname} aged ${amateur.age}`;
          }
          this.apply({
            amateur: amateur,
            nickname: amateur.getNickname(),
            age: amateur.age,
            from: await amateur.getLocation(),
            click: (ev) => {
              if (closest(ev.target, ignoreClicks, undefined, this.box)) {
                return;
              }
              amateur.goto();
            },
            desc: amateur.getDescription()
          });
          if (!scope.image || scope.forceProfileImage) {
            scope.image = amateur.getImageUrl(scope.imageFormat || '800');
          }
          await super.load(scope, {});
          return amateur;
        } catch (err) {
          await super.load(scope, {});
          throw err;
        }
      }
      hookname() {
        return 'tileAmateur';
      }
    }
    return AmateurTile;
  }]);
